import Skeleton from 'react-loading-skeleton';

const PromoSkeleton = () => {
  return (
    <div className="mx-auto w-full max-w-xl p-10">
      <section className="rounded-md bg-white-100 p-4 bp2:p-6">
        <Skeleton count={1} className="my-6" height={200} />
        <Skeleton count={1} className="my-6" height={32} />
      </section>
    </div>
  );
};

export default PromoSkeleton;
